<div class="header">
  <div class="left-icons">
    <button (click)="onClose()" mat-icon-button aria-label="Back">
      <mat-icon title="Back">arrow_back</mat-icon>
    </button>
  </div>
  <div class="title">
    @if (!isNew) {
      Edit onsite test
    }
    @if (isNew) {
      Add onsite test
    }
  </div>
  <div class="right-icons">
    <button type="button" class="mat-inline-button" mat-button color="primary" (click)="saveAll()"
    [disabled]="!lineItems?.length">Done</button>
  </div>
</div>

<div class="body">
  @if (initialized) {
    <!-- Internal test selector -->
    <section>
      <div class="mat-body-2">Onsite test:</div>
      <mat-form-field>
        <mat-select [(value)]="internalTest" (selectionChange)="init()">
          @for (it of internalTests; track it) {
            <mat-option [value]="it">{{it.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </section>
    <!-- /Internal test selector -->
    <!-- Bid Item section -->
    <section>
      <div class="mat-body-2">Bid item:</div>
      @if (biditem) {
        <div class="card link" (click)="openBidItemSelector()">
          <div class="mat-subtitle-1">{{biditem?.item}}</div>
          <div>{{biditem.description}}</div>
        </div>
      }
      @if (!biditem) {
        <div class="input-placeholder" (click)="openBidItemSelector()">
          <button mat-icon-button color="accent">
            <mat-icon>add</mat-icon>
          </button>Add bid item
        </div>
      }
    </section>
    <!-- /Bid Item section -->
    <!-- Heading selector -->
    <section>
      <div class="mat-body-2">Heading:</div>
      <mat-form-field>
        <mat-select (selectionChange)="byStation && onHeadingChange($event.value)" [(value)]="heading">
          @for (heading of headings; track heading) {
            <mat-option [value]="heading">{{heading.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </section>
    <!-- /Heading selector -->
    <!-- Add lineitem -->
    <section>
      <div class="row">
        <div class="mat-body-2">
          @if (byStation) {
            Station
          }
          @if (!byStation) {
            Time
          }
        </div>
        <div class="icons">
          <button mat-icon-button (click)="addLineItem()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </section>
    <!-- /Add lineitem -->
    <!-- Lineitem Forms -->
    @if (lineItems.length) {
      <mat-accordion class="line-items">
        @for (li of lineItems; track li) {
          <mat-expansion-panel [expanded]="li._id === selectedItem?._id">
            <mat-expansion-panel-header (click)="selectLineItem(li)">
              <div class="header-row">
                <span>
                  @if ((!li._inputForm.valid && !li._inputForm.pristine)) {
                    <mat-icon color="warn">error</mat-icon>
                  }
                  @if (byStation) {
                    {{li?.station?.name}}
                  }
                  {{li?.recordTimeZ | dateFormat: "h:mm a"}}
                  @if (li.getFieldValueSummary(fields)) {
                    <span class="mat-caption"
                      >&nbsp;({{li.getFieldValueSummary(fields)}})
                    </span>
                  }
                </span>
                <div class="icons">
                  <!-- More menu -->
                  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="delete(li)">
                      <mat-icon>delete</mat-icon>
                      @if (byStation) {
                        <span>Remove station</span>
                      }
                      @if (!byStation) {
                        <span>Remove Time</span>
                      }
                    </button>
                  </mat-menu>
                  <!-- /More menu -->
                </div>
              </div>
            </mat-expansion-panel-header>
            <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{'rit': li}">
            </ng-container>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
    <!-- /Lineitem Forms -->
    <!-- Delete all items -->
    <section>
      <br />
      <button type="button" class="mat-inline-button" mat-button color="primary" (click)="deleteAll()"
        [disabled]="!lineItems?.length">
        <mat-icon>delete</mat-icon> Delete onsite test
      </button>
    </section>
    <!-- /Delete all items -->
  }
</div>

@if (initialized) {
  <div class="footer">
    @if (selectedItem) {
      <app-report-item-toolbar [lineItem]="selectedItem" [project]="project"
      (changed)="onLineItemChange($event)"></app-report-item-toolbar>
    }
  </div>
}


<ng-template #SingleForm let-rit="rit">
  <form [formGroup]="rit._inputForm">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
    </section>

    <section class="custom-fields">
      <!-- record_time section -->
      <section class="width-50">
        <div class="mat-body-2">Time:</div>
        <mat-form-field>
          <ngx-material-timepicker #recordTime></ngx-material-timepicker>
          <input matInput autocomplete="off" [ngxTimepicker]="recordTime" [format]="24" formControlName="record_time"
            [errorStateMatcher]="matcher" />
          @if (rit._inputForm.controls.record_time.hasError('required')) {
            <mat-error>
              This field is required
            </mat-error>
          }
          @if (rit._inputForm.controls.record_time.hasError('error')) {
            <mat-error>
              {{rit._inputForm.controls.record_time.errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </section>
      <!-- /record_time section -->

      <!-- station_id section -->
      @if (byStation) {
        <section class="width-50">
          <div class="mat-body-2">Station:</div>
          <mat-form-field>
            <input type="text" matInput formControlName="station_id" [errorStateMatcher]="matcher"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              @for (option of stationOptions | async; track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-autocomplete>
            @if (rit._inputForm.controls.station_id.hasError('required')) {
              <mat-error>
                This field is required
              </mat-error>
            }
            @if (rit._inputForm.controls.station_id.hasError('error')) {
              <mat-error>
                {{rit._inputForm.controls.station_id.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        </section>
      }
      <!-- /station_id section -->

      @for (field of fields; track field) {
        <app-field-input [field]="field" [form]="rit._inputForm" [matcher]="matcher"
        [class]="getWidth(field)"></app-field-input>
      }
    </section>
    <div style="clear: both"></div>
  </form>
  <ng-container [ngTemplateOutlet]="readOnlyToolbarItems" [ngTemplateOutletContext]="{'li': rit}"></ng-container>
</ng-template>



<ng-template #readOnlyToolbarItems let-li="li">
  @if (li.pictures.length) {
    <section>
      <div class="mat-body-2">Pictures:</div>
      <div class="preview-list">
        @for (pic of li.pictures; track pic) {
          <div>
            <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, li.pictures, pic)" />
          </div>
        }
      </div>
    </section>
  }

  @if (li.annotations.length) {
    <section>
      <div class="mat-body-2">Annotations:</div>
      <div class="preview-list">
        @for (ann of li.annotations; track ann) {
          <div>
            <img [src]="ann.getThumbnail()" class="link" />
          </div>
        }
      </div>
    </section>
  }

  @if (!li.location.isEmpty) {
    <section>
      <div class="mat-body-2">Location:</div>
      <div>
        <app-location-picker [isDialog]="false" [latitude]="li.location.lat" [longitude]="li.location.lng" height="100px"
        [readOnly]="true"></app-location-picker>
      </div>
    </section>
  }

  @if (li.comment) {
    <section>
      <div class="mat-body-2">Comment:</div>
      <mat-form-field appearance="outline">
        <textarea matInput rows="5" [value]="li.comment" [disabled]="true"></textarea>
      </mat-form-field>
    </section>
  }
</ng-template>